import React from 'react';
import PropTypes from 'prop-types';

import ChatUserIcon from '../ChatUserIcon';
import { UserContainer, UserName }  from './components';
import {ReactComponent as CircleIcon} from "../../../../img/icon-circle.svg";
import Icon from "../../Common/Icon";

const ChatUserRowOption = ({ user, onClick }) => {
  return (
    <UserContainer onClick={() => onClick(user)}>
      {/*<ChatUserIcon user={user} />*/}
      <Icon
        width='10'
        height='10'
        color={ user.online ? 'successColor' : 'errorColor' }
      >
        <CircleIcon alt='icon-circle'/>
      </Icon>
      <UserName>
        {user.name}
      </UserName>
    </UserContainer>
  )
};

ChatUserRowOption.propTypes = {
  user: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired
};

export default React.memo(ChatUserRowOption);